const loadpage = (state) => state.loadpage
const dark = (state) => state.dark
const keepPageState = (state) => state.keepPageState
const imageToView = (state) => state.imageToView
const productImageToView = (state) => state.productImageToView
const messageData = (state) => state.messageData

export default {
  loadpage,
  dark,
  imageToView,
  keepPageState,
  messageData,
  productImageToView
}
